import {
  CONSUMER_EULA_URL,
  CONSUMER_TERMS_URL,
  PRO_TERMS_EMEA_URL,
  PRO_TERMS_NA_URL,
  PRIVACY_POLICY_URL,
  PRIVACY_POLICY_URL_MIDDLE_EAST,
  MIDDLE_EAST_COUNTRIES,
} from 'config';
import { isEMEA } from 'config/regions';

export const isChildCulture = (cultureCode: string): boolean => {
  return cultureCode.includes('-');
};

export const getParentCulture = (cultureCode: string): string => {
  return isChildCulture(cultureCode) ? cultureCode.split('-')[0] : cultureCode;
};

export const getCompatibleCultureCode = (
  supportedCultures: string[],
  userLanguages: readonly string[]
): string => {
  return (
    supportedCultures.find(
      element =>
        isChildCulture(element) &&
        userLanguages.some(lang => lang.toLowerCase() === element.toLowerCase())
    ) ||
    supportedCultures.find(
      element =>
        getParentCulture(element) !== 'en' &&
        userLanguages.some(
          lang => lang.toLowerCase() === getParentCulture(element).toLowerCase()
        )
    ) ||
    supportedCultures.find(element => getParentCulture(element) === 'en') ||
    supportedCultures[0] ||
    ''
  );
};

export const isMiddleEastCountry = (countryCode?: string): boolean => {
  if (!countryCode) return false;
  return MIDDLE_EAST_COUNTRIES.includes(countryCode.toLowerCase());
};

export const getTermsUrls = (
  country: string,
  languages: readonly string[],
  supportedLanguages: {
    consumerTerms: string;
    consumerEula: string;
    proTermsNA: string;
    proTermsEMEA: string;
  }
) => {
  const proTermsSupportedLanguages = isEMEA(country)
    ? supportedLanguages.proTermsEMEA.split(',')
    : supportedLanguages.proTermsNA.split(',');

  const consumerTermsSupportedLanguages =
    supportedLanguages.consumerTerms.split(',');
  const consumerEulaSupportedLanguages =
    supportedLanguages.consumerEula.split(',');

  const proTermsCulture = getCompatibleCultureCode(
    proTermsSupportedLanguages,
    languages
  );
  const consumerTermsCulture = getCompatibleCultureCode(
    consumerTermsSupportedLanguages,
    languages
  );
  const consumerEulaCulture = getCompatibleCultureCode(
    consumerEulaSupportedLanguages,
    languages
  );

  const proTermsBaseUrl = isEMEA(country)
    ? PRO_TERMS_EMEA_URL
    : PRO_TERMS_NA_URL;

  return {
    proTermsUrl: proTermsCulture
      ? new URL(proTermsCulture, proTermsBaseUrl).href
      : proTermsBaseUrl,
    consumerTermsUrl: consumerTermsCulture
      ? new URL(consumerTermsCulture, CONSUMER_TERMS_URL).href
      : CONSUMER_TERMS_URL,
    consumerEulaUrl: consumerEulaCulture
      ? new URL(consumerEulaCulture, CONSUMER_EULA_URL).href
      : CONSUMER_EULA_URL,
    privacyPolicyUrl: isMiddleEastCountry(country)
      ? PRIVACY_POLICY_URL_MIDDLE_EAST
      : PRIVACY_POLICY_URL,
  };
};
